import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
  id: string;
  name: string;
  email?: string;
  photoUrl?: string;
  language?: "es" | "en";
  acceptsTerms?: boolean;
  acceptsPrivacy?: boolean;
}

interface AuthState {
  isAuthenticated: boolean;
  user?: User;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<User>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      localStorage.setItem("userState", JSON.stringify(state.user));
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = undefined;
      localStorage.removeItem("userState");
    },
    updateUser: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
        localStorage.setItem("userState", JSON.stringify(state.user));
      }
    },
    clearAuth: (state) => {
      state.isAuthenticated = false;
      state.user = undefined;
      localStorage.removeItem("userState");
    },
  },
});

export const { login, logout, updateUser, clearAuth } = authSlice.actions;
export default authSlice.reducer;
